<!--
  PageHeader Component
  Title + optional breadcrumbs + optional action buttons.
  Used at the top of each page/view.
-->
<script lang="ts">
  import Breadcrumbs from '../ui/Breadcrumbs.svelte';

  export let title: string;
  export let subtitle: string | undefined = undefined;
  export let breadcrumbs: Array<{ label: string; href?: string }> | undefined = undefined;
</script>

<div class="mb-6">
  {#if breadcrumbs}
    <div class="mb-2">
      <Breadcrumbs items={breadcrumbs} />
    </div>
  {/if}

  <div class="flex items-start justify-between gap-4">
    <div>
      <h1 class="text-2xl font-semibold text-text">{title}</h1>
      {#if subtitle}
        <p class="mt-1 text-sm text-text-secondary">{subtitle}</p>
      {/if}
    </div>

    {#if $$slots.actions}
      <div class="flex items-center gap-2 shrink-0">
        <slot name="actions" />
      </div>
    {/if}
  </div>
</div>
